<template>
    <div>
        <vue-headful title="ABL Groupe | Forge libre" />
        <carousel class="carousel-free-forge" :perPageCustom="[[500, 1]]">
            <slide class="gallery-cell"><img :src="require('../assets/images/Image1.jpg')"/></slide>
            <slide class="gallery-cell"><img :src="require('../assets/images/bjorneborg.jpg')"/></slide>
            <slide class="gallery-cell"><img :src="require('../assets/images/forgefedriga.jpg')"/></slide>
            <slide class="gallery-cell"><img :src="require('../assets/images/Image2.png')"/></slide>
        </carousel>
        <main>
            <div class="container">
                <h2>Forge Libre / <em>Open Die Forging</em></h2>
                <section class="box--container">
                    <SubProductBox v-for="(subproduct, index) in require('../data/freeforge').default" :product="subproduct"
                                   :key="index"/>
                </section>
            </div>
        </main>
    </div>
</template>

<script>
    import {Carousel, Slide} from 'vue-carousel';
    import SubProductBox from "../components/SubProductBox";
    export default {
        name: "Freeforge",
        components: {
            Carousel,
            Slide,
            SubProductBox
        }
    }
</script>

<style scoped>
    .carousel-free-forge {
        margin-top: -50px;
    }
    .carousel-free-forge img {
        height: 500px;
        width: 100%;
    }
    .gallery-cell {
        margin-bottom: -80px;
    }
</style>